import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {FeatureStatusCard} from 'shells/card/feature-status-card';
import {SlideshowControls} from 'shells/carousel/slideshow-controls';
import {colors} from 'shells/colors/colors';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {RightFrame, FooterWithControls, ModalMain} from 'shells/modal/step-modal/layout';
import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';

import {getServiceNoun, getServiceTypeIconComponent} from '../../../calls/helpers';
import {useGetSessionUser} from '../../../core/use-get-session-user';

import {PhoneIntegrationDefaultProviderSetting} from '../phone-integration-default-provider-setting';

type Props = {
    name: string;
    phoneNumber: string;
    history: RouterHistory;
};

export function ClickToCallConnected(props: Props) {
    const {name, phoneNumber, history} = props;

    const serviceNoun = getServiceNoun('CLICKTOCALL');

    const {user, isLoading} = useGetSessionUser();

    const phoneIntegrations = user ? user.phoneIntegrations : [];
    const enabledPhoneIntegrations = phoneIntegrations.filter(
        (integration) => integration.isEnabledForUser
    );

    React.useEffect(() => {
        window.dispatchEvent(new Event('onboarding-step-completed'));
    }, []);

    if (isLoading) {
        return (
            <RightFrame>
                <LoadingPage size={64} fill={colors.blueLt} />
            </RightFrame>
        );
    }

    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Great, you’re connected!</ModalHeader>
                <Stack spacing={24}>
                    <Body>Calling from Nutshell is now just a click away.</Body>
                    <FeatureStatusCard
                        icon={getServiceTypeIconComponent('CLICKTOCALL')}
                        iconFill={colors.orange}
                        title={`Nutshell ${serviceNoun}`}
                        subtitle={name}
                        tertiaryData={phoneNumber}
                        statusBadge={{
                            text: 'Connected',
                            level: 'success',
                        }}
                    />
                    <PhoneIntegrationDefaultProviderSetting
                        enabledPhoneIntegrations={enabledPhoneIntegrations}
                        clickToCallEnabled={true}
                        showSavedToast={true}
                        onError={() => {}}
                        radioGroupName='configure default provider - modal'
                    />
                </Stack>
            </ModalMain>
            <FooterWithControls
                controls={<SlideshowControls selectedSlide={2} slideCount={4} />}
                buttons={
                    <React.Fragment>
                        <Button variant='text' onClick={history.goBack}>
                            Back
                        </Button>
                        <SaveButton
                            variant='primary'
                            size='big'
                            // @ts-expect-error
                            onClick={() => {
                                history.push(
                                    '/connect-phone-integration/configure-activity-types?integrationType=CLICKTOCALL'
                                );
                            }}
                            buttonText='Next'
                            isSaving={false}
                        />
                    </React.Fragment>
                }
            />
        </RightFrame>
    );
}
